import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import { GlobalProviders } from './components/providers/GlobalProviders';
import { ProveedorProvider } from './context/ProveedorContext';
import { EmpleadoProvider } from './context/EmpleadoContext';

import Layout from './components/layouts/AppLayout';
import AuthLayout from './components/layouts/AuthLayout';
import PublicRoute from './components/auth/PublicRoute';
import ProtectedRoute from './components/auth/ProtectedRoute';
import LoadingFallback from './components/ui/feedback/LoadingFallback';

// Lazy Load Modules
const Dashboard = lazy(() => import('./page/app/Dashboard'));
const Proveedores = lazy(() => import('./page/app/proveedores/Proveedores'));
const Empleados = lazy(() => import('./page/app/empleados/Empleados'));
const IVA = lazy(() => import('./page/app/retenciones/i.v.a/IVA'));
const ISLR = lazy(() => import('./page/app/retenciones/I.S.L.R/ISLR'));
const RetentionARCV = lazy(() => import('./page/app/retenciones/ARCV/RetentionARCV'));
const OtrosImpuestos = lazy(() => import('./page/app/retenciones/Otros-Impuestos/OtrosImpuestos'));
const CompanyProfile = lazy(() => import('./page/app/configuracion/CompanyProfile'));
const LoginPage = lazy(() => import('./page/auth/LoginPage'));

function App() {
  return (
    <GlobalProviders>
      <Suspense fallback={<LoadingFallback />}>
        <Routes>
          {/* Ruta pública de login con Layout propio y redirección si ya está logueado */}
          <Route
            path="/login"
            element={
              <PublicRoute>
                <AuthLayout>
                  <LoginPage />
                </AuthLayout>
              </PublicRoute>
            }
          />

          {/* Rutas protegidas con Layout */}
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <Layout>
                  <Routes>
                    <Route path="/" element={<Dashboard />} />

                    <Route path="/proveedores" element={
                      <ProveedorProvider>
                        <Proveedores />
                      </ProveedorProvider>
                    } />

                    <Route path="/empleados" element={
                      <EmpleadoProvider>
                        <Empleados />
                      </EmpleadoProvider>
                    } />

                    <Route path="/retenciones/iva" element={
                      <IVA />
                    } />

                    <Route path="/retenciones/islr" element={
                      <ISLR />
                    } />

                    <Route path="/retenciones/islr-empleados" element={
                      <RetentionARCV />
                    } />

                    {/* Otros Impuestos no tiene Context propio aun, o usa uno generico si existe */}
                    <Route path="/retenciones/otros" element={<OtrosImpuestos />} />

                    <Route path="/configuracion" element={<CompanyProfile />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                  </Routes>
                </Layout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </Suspense>
    </GlobalProviders>
  );
}

export default App;